import * as UI from '@brewlogix/blx-ui'

import AmenitiesPill from './Amenities/AmenitiesPill'
// Constants
import { Location } from 'src/types/schema/graphql'
import tailwindConfig from '@brewlogix/blx-ui/tailwind.config'
import React from 'react'
import { parseEnumLabel } from 'src/util/helpers'
import { activityTypes } from '../utils/constants'
import { getOption } from '../utils/helpers'
import classNames from 'classnames'

interface IActivitiesLocationSlug {
    location: Location
}

const ActivitiesLocationSlug: React.FC<IActivitiesLocationSlug> = ({ location }) => {
    const getActivityLength = (activity) => {
        if (!activity) return false
        if (Array.isArray(activity) && activity.length > 0) {
            return true
        }
        return false
    }
    const icons = Object.keys(tailwindConfig.theme.icons)

    const noDataTitle = 'Activities coming soon...'
    const activitiesList = !location
        ? []
        : activityTypes.filter((val) => getActivityLength(location.traits[val]))

    const data = location.traits

    return (
        <div className=''>
            <div className='bdb-location__detail border-b-px border-gray-100 pb-6'>
                <div className='flex items-center'>
                    <UI.Heading
                        text='Activities'
                        size='h6'
                        theme='default'
                        customClasses='text-lg text-gray-500 font-bold'
                    />
                </div>
                {activitiesList.length === 0 && <div className='flex'>{noDataTitle}</div>}
                <div className='mt-4 grid grid-cols-2 items-baseline gap-3'>
                    {activitiesList.map((activityType) => (
                        <div
                            key={`cell-${activityType}`}
                            className='flex flex-wrap justify-start gap-2'
                        >
                            {data[activityType].map((activity) => {
                                const iconExists = icons.includes(getOption(activity))
                                return iconExists ? (
                                    <AmenitiesPill key={activity} item={activity} />
                                ) : (
                                    <UI.Pill
                                        theme='default'
                                        shape='full'
                                        label={parseEnumLabel(activity)}
                                        size='md'
                                        key={activity}
                                        customClasses='border-0 bg-transparent -ml-3'
                                    />
                                )
                            })}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default ActivitiesLocationSlug
